<template>
    <section class="l-section l-section--main">
        <div
            class="l-container l-container--main l-container--horizontalPaddings"
        >
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <h1 class="a-title">Podaj nowe hasło</h1>
                    <form
                        class="a-mobile o-form"
                        @submit.prevent="handleSubmit"
                    >
                        <div class="a-control o-form__group">
                            <label
                                class="a-label a-control__label"
                                for="userPassword"
                                >Nowe hasło</label
                            >
                            <input
                                id="userPassword"
                                class="a-control__input"
                                v-model="password"
                                type="password"
                                autocomplete="new-password"
                                :style="
                                    passwordError
                                        ? 'border-color: #ED535C'
                                        : 'border-color: #EBEBEB'
                                "
                            />
                            <p
                                class="a-text"
                                :style="
                                    passwordError
                                        ? 'color: #ED535C'
                                        : 'color: #EBEBEB'
                                "
                            >
                                {{ passwordErrorMessage }}
                            </p>
                        </div>
                        <div class="a-control o-form__group">
                            <label
                                class="a-label a-control__label"
                                for="userPassword"
                                >Powtórz hasło</label
                            >
                            <input
                                id="userPassword2"
                                class="a-control__input"
                                v-model="passwordRepeat"
                                type="password"
                                autocomplete="new-password"
                                :style="
                                    passwordRepeatError
                                        ? 'border-color: #ED535C'
                                        : 'border-color: #EBEBEB'
                                "
                            />
                            <p
                                class="a-text"
                                :style="
                                    passwordRepeatError
                                        ? 'color: #ED535C'
                                        : 'color: #EBEBEB'
                                "
                            >
                                {{ passwordRepeatErrorMessage }}
                            </p>
                        </div>
                        <o-notifications
                            :is-static="true"
                            name="dashboard-reset-password-2"
                        />
                        <o-notifications
                            :is-static="true"
                            name="dashboard-login"
                        />
                        <div class="o-form__buttons">
                            <div class="a-mobile__buttons">
                                <a-button
                                    class="a-button"
                                    @click="
                                        $router.push({
                                            name: 'dashboard-login'
                                        })
                                    "
                                >
                                    Powrót
                                </a-button>
                                &nbsp;
                                <a-button
                                    class="a-button a-button--primary"
                                    :is-processing="authStatus === 'pending'"
                                    type="submit"
                                >
                                    Zmień hasło
                                    <a-icon
                                        class="a-button__icon"
                                        icon="Right"
                                    />
                                </a-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            passwordRepeat: '',
            passwordError: false,
            passwordErrorMessage: '',
            passwordRepeatError: false,
            passwordRepeatErrorMessage: ''
        }
    },
    computed: {
        authStatus() {
            return this.$store.getters['users/status']
        }
    },
    methods: {
        handleSubmit() {
            this.$store
                .dispatch('users/resetPasswordStep2', {
                    token: this.$route.params.token,
                    password: this.password,
                    passwordRepeat: this.passwordRepeat
                })
                .then(response => {
                    this.passwordError = false
                    this.passwordErrorMessage = ''
                    this.passwordRepeatError = false
                    this.passwordRepeatErrorMessage = ''
                    this.$router.push({ name: 'dashboard-login' })
                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: response,
                        limit: 0,
                        name: 'dashboard-login'
                    })
                })
                .catch(error => {
                    const errors = error.response.data.data.errors
                    if (errors['password._empty']) {
                        this.passwordError = true
                        this.passwordErrorMessage = errors['password._empty']
                    }
                    if (errors['password.minlength']) {
                        this.passwordError = true
                        this.passwordErrorMessage = errors['password.minlength']
                    }
                    if (errors['passwordRepeat._empty']) {
                        this.passwordRepeatError = true
                        this.passwordRepeatErrorMessage =
                            errors['passwordRepeat._empty']
                    }
                    if (errors['passwordRepeat.minlength']) {
                        this.passwordRepeatError = true
                        this.passwordRepeatErrorMessage =
                            errors['passwordRepeat.minlength']
                    }
                    if (errors['passwordRepeat.compare']) {
                        this.passwordRepeatError = true
                        this.passwordRepeatErrorMessage =
                            errors['passwordRepeat.compare']
                    } else {
                        this.passwordRepeatErrorMessage =
                            errors['passwordRepeat._empty']
                    }
                    if (errors[0]) {
                        this.passwordError = true
                        this.passwordErrorMessage =
                            errors[0]
                    }

                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił bład',
                        limit: 0,
                        name: 'dashboard-login'
                    })
                })
        }
    }
}
</script>
